import { render, staticRenderFns } from "./Joined.vue?vue&type=template&id=ff0154b6&"
import script from "./Joined.vue?vue&type=script&lang=js&"
export * from "./Joined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports